module.exports = __webpack_public_path__ + "img/mobile-logo.df06f71c.svg";